import { Textarea, TextareaProps } from "@chakra-ui/react"
import React from "react"

const ExpandingInput = (props: TextareaProps): JSX.Element => {
  return (
    <Textarea {...props} overflow="hidden" resize="none" enterKeyHint="send" />
  )
}

export default ExpandingInput
